// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".author__warning_message_cb7ee801{background-color:#fee0d0;border:solid .084rem #84919b;color:#b32700}", ""]);
// Exports
export var authorWarningMessage = "author__warning_message_cb7ee801";
export default ___CSS_LOADER_EXPORT___;
